import moment from 'moment';

export const formatDate = (value) => {
  if (value) {
    return moment(String(value)).format('ll');
  }
};
export const formatFilterDate = (value) => {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD');
  }
};
export const formatChartDate = (value) => {
  return value ? moment(String(value)).format('MM/DD') : value;
};

export const formatInputDate = (value) => {
  if (value) {
    return moment(value).toDate().toUTCString();
  }
};

export const displayDateTime = (value) => {
  if (value) {
    return moment(
        String(value)
      ).format("YYYY-MM-DD hh:mm");
  }
};

